<template>
  <div class="adminhome" style="min-height:85vh;overflow-x: hidden;position: relative;">
    <div v-if="isLoading" style="position: absolute;left: 50%;z-index: 3;margin-left:-50px;display: inline-flex;text-align: center;top:190px;border-radius: 4px;">
      <LoadingBar />
    </div>
    <div style="display:flex">
      <div style="margin: 16px 0;display:flex">
        <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
          <a-breadcrumb-item style="font-size:30px;">Offer Codes</a-breadcrumb-item>
          <!-- <a-breadcrumb-item>Bill</a-breadcrumb-item> -->
        </a-breadcrumb>
        <a-button style="margin-top:auto;margin-bottom:auto;margin-left:20px" type="primary">
          <router-link to="/admin/addoffercode">
            Add Offer Code
          </router-link>
        </a-button>
      </div>
    </div>
    <export-excel style="margin-left:5px;position:absolute;top: 0;right: 0;" class="btn-default" :data="json_data"
      :fields="json_fields" :meta="json_meta" type="xls" worksheet="Offer Codes" name="Offer Codes Data.xls">
      Export Excel
    </export-excel>

    <div style="position:relative">
      <div style="position:absolute;right:0;top:-30px;display:flex;">
        <a-input-search style="width:400px;margin-right:0px;margin-left:auto" v-model="offerCodeSearchText"
          placeholder="" @search="onSearch">
          <a-button slot="enterButton">
            Search Offer code
          </a-button>
        </a-input-search>
      </div>
      <OfferCodeTableItem :key="tableCellCount" :offercodelist="offercodelist" :columns="columns"
        :tableCellCount="tableCellCount" @listUpdate="listUpdate" @listFilterCount="listFilterCount" />
    </div>
  </div>
</template>
<script>

import { api } from '../helpers/Helpers';
import OfferCodeTableItem from './TableItems/OfferCodeTableItem.vue';
import LoadingBar from '@/components/LoadingBar.vue';

const columns = [
  {
    title: 'Offer Code Name',
    dataIndex: 'name',
    key: 'name',
    sorter: true
  },
  {
    title: 'Offer Code Value',
    dataIndex: 'value',
    key: 'value',
    sorter: true
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: 'Creator',
    dataIndex: 'creatorName',
    key: 'creatorName',
    sorter: true
  },
  // {
  //   title: 'Created Date',
  //   dataIndex: 'createdDate',
  //   key: 'createdDate',
  //   sorter: true,
  //   scopedSlots: { customRender: 'createdDate' },
  // },
  {
    title: 'Action',
    key: 'action',
    width: 200,
    scopedSlots: { customRender: 'action' },
  }
];

export default {
  data() {
    return {
      alloffercodelist: [],
      offercodelist: [],
      columns,
      offerCodeSearchText: "",
      isLoading: false,
      tableCellCount: 10,

      json_fields: {
        'Offer Code Name': 'Offer Code Name',
        'Offer Code Value': 'Offer Code Value',
        'Description': 'Description',
        'Creator': 'Creator'
      },
      json_data: [
        {
          'Offer Code Name': '',
          'Offer Code Value': '',
          'Description': '',
          'Creator': ''
        }
      ],
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },

  components: {
    OfferCodeTableItem,
    LoadingBar
  },

  created: function () {
    this.getOfferCodes();
  },
  mounted() {
  },

  methods: {
    getOfferCodes: async function () {
      this.isLoading = true;
      try {
        let res = await api.getOfferCodes();
        this.alloffercodelist = res;
        this.offercodelist = [...this.alloffercodelist];
      } catch (error) {
        console.error('Error fetching offer codes:', error);
      } finally {
        this.isLoading = false;
      }
    },
    onSearch(value) {
      const search = this.offerCodeSearchText.toLowerCase();
      this.offercodelist = this.alloffercodelist.filter(d => d.name.toLowerCase().includes(search) || d.description.toLowerCase().includes(search) || d.creatorName.toLowerCase().includes(search));
    },
    listUpdate() {
      this.getOfferCodes();
    },
    listFilterCount(_count) {
      this.tableCellCount = _count;
    },
  }
};
</script>
